export default {
  zh: {
    upload: "资料上传",
    notes: "本界面的单个附件上限是5M，支付的附件格式包括.jpg,.jpeg,.png,.JPG,.JPEG,.PNG,.pdf,.PDF,.doc,.DOC",
    name: "姓名",
    company: "公司",
    nameOrCompany: "姓名/公司",
    shareholderOrCompany: "股东/公司",
    duty: "股东/董事",
    already: "已上传附件名称",
    identityTitle: "董事|股东(个人)的护照身份证件(含个人签字)",
    identityTitleSmall: "(与[1.公司取名]的申请信息相同)",
    identityTitle02: "董事|股东(个人)的手持身份证件原件的电子照片",
    identityUpload: "上传护照身份证件原件(含正反面)",
    identityHoldUpload: "上传显示本人手持护照身份证原件的电子照片(含人脸和显示人脸的护照身份证原件)或经鉴证的身份证明文件",
    siteTitle: "董事|股东的近三个月以内的地址证明原件扫描件",
    siteTitleSmall: "(例如: 含姓名、地址的水电或物业费等单据)(与[1.公司取名]的申请信息相同)",
    siteUpload: "上传地址证明原件",
    businessTitle: "股东(公司)的营业执照和章程原件扫描件",
    businessTitleSmall: "(与[1.公司取名]的申请信息相同)",
    businessUpload: "上传营业执照和章程原件",
    registeredTitle: "新申请公司的注册地址证明原件扫描件",
    registeredTitleSmall: "(如：租赁合同、房产持有证明)(与[3.设立信息]的申请信息相同)",
    registeredUpload: "上传注册地址证明原件",
    frameworkTitle: "新申请公司的股权架构图",
    frameworkTitleSmall: "(包含：股东名称、持股比例。股东涉及直接持股股东、间接持股股东、最终持股股东。)",
    frameworkUpload: "上传股权架构图",
    beneficiaryTitle: "若公司为股东，最终受益人的营业执照原件扫描件",
    beneficiaryUpload: "上传股东营业执照",
    authorizationTitle: "已取得的相关政府机构同意新设公司的授权文件(若适用)",
    authorizationTitleSmall: "(与[3.设立信息]的申请信息相同)",
    authorizationUpload: "上传新公司授权文件",
    legalConstitutionTitle: "上传经律师复核的定制化章程",
    legalConstitutionUpload: "上传经律师复核的定制化章程",
    applicantIdentityTitle: "申请人的身份证件原件扫描件",
    applicantIdentityTitle02: "申请人的手持身份证件原件的电子照片",
    notApplicantTitle: "本次申请的授权文件扫描件",
    authorizationFileUpload: "上传授权申请人设立公司的授权文件",
    applicantIdentityUpload: "上传申请人的护照身份证件原件(含正反面)",
    transferIdentityTitleSmall: "(与[1.KYC问卷]的申请信息相同)",
    transferSiteTitleSmall: "(例如: 含姓名、地址的水电或物业费等单据)(与[1.KYC问卷]的申请信息相同)",
    transferProfileAndArticles: "拟转移公司的Business Profile (营业执照) & 章程",
    transferProfileAndArticlesSmall: "(包含：拟转移公司的最新Business Profile (营业执照) 和最新章程)",
    transferProfileUpload: "上传营业执照和章程",
    transferActivities: "拟转移公司的经营活动",
    transferActivitiesSmall: "(包含：关于拟转移公司的主要产品和/或主要服务的描述、以及名义董事和/或名义股东的名称(若有))",
    transferDescribeUpload: "上传经营活动等信息",
    transferStructure: "拟转移公司的股权架构图",
    transferStructureSmall: "(包含：股东名称、持股比例、电邮、手机号码和收件地址。股东涉及直接持股股东、间接持股股东、最终持股股东)",
    transferStructureUpload: "上传股权架构图",
    transferFinancial: "拟转移公司的最新的年度财务报告(若适用)",
    transferFinancialUpload: "上传最新的年度财务报告",
    transferAddress: "拟转移公司的注册地址证明原件扫描件",
    transferAddressSmall: "(如：租赁合同、房产持有证明)",
    transferAddressUpload: "上传注册地址证明原件扫描件",
    transferSecretary: "拟转移公司的现任公司秘书的信息",
    transferSecretarySmall: "(包含：现任公司秘书的名称、电邮、手机号码和收件地址)",
    transferSecretaryUpload: "上传现任公司秘书的信息",

    comprehensiveProfileAndArticles: "公司的Business Profile (营业执照) & 章程",
    comprehensiveProfileAndFundArticles: "基金管理公司的Business Profile (营业执照) & 章程",
    comprehensiveProfileAndArticlesSmall: "(包含：公司的最新Business Profile (营业执照) 和最新章程)",
    comprehensiveProfileAndArticlesFundSmall: "(包含：基金管理公司的最新Business Profile (营业执照) 和最新章程)",
    comprehensiveProfileUpload: "上传营业执照和章程",
    comprehensiveActivities: "公司的经营活动",
    comprehensiveFundActivities: "基金的经营信息",
    comprehensiveActivitiesSmall: "(包含：关于公司的主要产品和/或主要服务的描述、以及名义董事和/或名义股东的名称(若有))",
    comprehensiveActivitiesFundSmall: "(包含：关于基金的主要基金类型、基金架构、投资策略、以及/或服务(若有))",
    comprehensiveDescribeUpload: "上传经营活动等信息",
    comprehensiveStructure: "公司的股权架构图",
    comprehensiveFundStructure: "基金管理公司的股权架构图",
    fundEquityStructure: "基金的股权架构图",
    comprehensiveStructureSmall: "(包含：股东名称、持股比例、电邮、手机号码和收件地址。股东涉及直接持股股东、间接持股股东、最终持股股东)",
    comprehensiveStructureUpload: "上传股权架构图",
    comprehensiveStructureFundUpload: "上传股权架构图",
    equityStructureFundUpload: "上传股权架构图",
    comprehensiveFinancial: "公司的最新的年度财务报告(若适用)",
    comprehensiveFundFinancial: "基金管理公司及其管理的基金的最新的年度财务报告(若适用)",
    comprehensiveFinancialUpload: "上传最新的年度财务报告",
    comprehensiveAddress: "公司的注册地址证明原件扫描件",
    comprehensiveFundAddress: "基金管理公司的注册地址证明原件扫描件",
    comprehensiveAddressSmall: "(如：租赁合同、房产持有证明)",
    comprehensiveAddressUpload: "上传注册地址证明原件扫描件",
    comprehensiveSecretary: "公司的现任公司秘书的信息",
    comprehensiveFundSecretary: "现任基金管理公司及其管理的基金的秘书公司的信息",
    comprehensiveSecretarySmall: "(包含：现任公司秘书的名称、电邮、手机号码和收件地址)",
    comprehensiveSecretaryFundSmall: "(包含：现任基金管理公司及其管理的基金的秘书公司的名称、电邮、手机号码和收件地址)",
    comprehensiveSecretaryUpload: "上传现任公司秘书的信息",
    comprehensiveSecretaryFundUpload: "上传现任基金管理公司及其管理的基金的秘书公司的信息",
    comprehensiveFinance: "公司的财务主管和税务主管的信息",
    comprehensiveFundFinance: "基金管理公司及其管理的基金的财务主管、税务主管、审计师的信息",
    comprehensiveFinanceSmall: "(包含：现任的财务主管和税务主管的名称、电邮、手机号码和收件地址。)",
    comprehensiveFinanceFundSmall: "(包含：现任的基金管理公司及其管理的基金的财务主管、税务主管、审计师的名称、电邮、手机号码和收件地址。)",
    comprehensiveFinanceUpload: "上传公司的财务主管和税务主管的信息",
    comprehensiveFinanceFundUpload: "上传基金管理公司及其管理的基金的财务主管、税务主管、审计师的信息",
    comprehensiveIdentityTitleSmall: "(与[1.KYC问卷]的申请信息相同)",
    comprehensiveSiteTitleSmall: "(例如: 含姓名、地址的水电或物业费等单据)(与[1.KYC问卷]的申请信息相同)",
    comprehensiveBusinessTitleSmall: "(与[1.KYC问卷]的申请信息相同)",

    fundMessage: "基金信息",
    fundMessageTitleSmall: "(i)基金营业执照Business Profile of Fund(s); (ii)基金认购备忘录(offering memo); (iii)有关基金类型、基金架构、基金投资策略和/或服务的说明文件",
    fundMessageIncludingUpload: "上传基金说明文件",
    fundMessageMemoUpload: "上传基金认购备忘录(offering memo)",
    fundBusinessProfileUpload: "上传基金营业执照",

    fundPassport: "基金的董事|股东(个人)的护照身份证件",
    fundSiteTitle: "基金的董事|股东的近三个月以内的地址证明原件扫描件",
    fundBusinessTitle: "基金的股东(公司)的营业执照和章程原件扫描件",

    fundManagerPassport: "基金管理公司的董事|股东(个人)的护照身份证件",
    fundManagerSiteTitle: "基金管理公司的董事|股东的近三个月以内的地址证明原件扫描件",
    fundManagerBusinessTitle: "基金管理公司的股东(公司)的营业执照和章程原件扫描件",
    certificationRequirements: `鉴证要求:\n
      鉴证文件是由鉴证人证明为真实副本的文件。鉴认证文件上必须说明以下详细信息:\n
      (a)鉴证人的姓名;\n
      (b)鉴证人签名;\n
      (c)鉴证日期(日期需在近三个月以内);\n
      (d)鉴证人的公章/印章(如适用);\n
      (e)鉴证机构的联系方式，包括电话号码、地址和电子邮件地址。
      `,
    promotionCertified: "上传与促销编号相关的支持文件，若有疑问，请联系我们的客户",
    promotionCertifiedUpload: "上传与促销编号相关的支持文件",
    ultimateBeneficialId: "最终受益人的身份证件/营业执照和地址证明",
    ultimateBeneficialIdTitleSmall: "(例如：含姓名和地址的身份证/营业执照)(与[1.KYC问卷]的申请信息相同)(若资料已上传至本页其他地方，则上传取名“ N/A”的text文档即可)",
    ultimateBeneficialIdTitleSmall02: "(例如：含姓名和地址的身份证/营业执照)(与[2.KYC问卷]的申请信息相同)(若资料已上传至本页其他地方，则上传取名“ N/A”的text文档即可)",
    ultimateBeneficialIdUpload: "上传含姓名和地址的身份证/营业执照",
    epApplicantPersonalInfo: "EP申请人的个人信息 ",
    epApplicantPersonalInfoTitleSmall: "(包含：护照、当地身份证证件、学位证书原件扫描件)(与[3.设立信息]的申请信息相同)",
    epApplicantPersonalInfoUpload: "上传护照、当地身份证证件、学位证书原件扫描件",
  },
  en: {
    upload: "Upload",
    notes: "Each attachment is limited to 5MB with the format limited to .jpg, .jpeg, .png, .JPG, .JPEG, .PNG, .pdf, .PDF, .doc, .DOC",
    identityTitle: "Passport / IC of Individual Shareholder(s) and Director(s) with Individual's Signature",
    identityTitleSmall: '(same as applied info in "1. Company Name")',
    identityTitle02: "Director | shareholder (individual) holding identity certificate of the original electronic photos",
    identityUpload: "Upload the original passport / IC (both front and back)",
    identityHoldUpload:
      "Upload a photo showing the person holding his/her original passport/IC (i.e. the individual's face and the front side of passport/IC showing the face needs to be included) or certified copy of passport / IC",
    name: "Name",
    company: "Company",
    duty: "Shareholder/Director",
    shareholderOrCompany: "Shareholder/Company",
    nameOrCompany: "Name/Company",
    already: "Upload",
    siteTitle: "Proof of Resident/Company Address – Scanned Copy",
    siteTitleSmall: '(i.e. recent three months\' utility bills, telephone bills, or third-party letters with name and address) (same as applied info in "1. Company Name")',
    siteUpload: "Upload the proof of address",
    businessTitle: "Corporate Shareholder's Business Certificate & Articles of Association – Scanned Copy",
    businessTitleSmall: '(same as applied info in "1. Company Name")',
    businessUpload: "Upload the business certificate & Articles of Association",
    registeredTitle: "Proof of Registered Office Address of the Proposed Company – Scanned Copy",
    registeredTitleSmall: '(i.e. lease agreement, or property ownership certificate) (same as applied info in "3. Company Details")',
    registeredUpload: "Upload the proof of registered office address",
    frameworkTitle: "Shareholder Structure of the Proposed Company",
    frameworkTitleSmall: "(i.e. shareholder structure chart, including name of direct/intermediary/ultimate shareholder(s), and shareholding ratio.)",
    frameworkUpload: "Upload shareholder structure of the proposed company",
    beneficiaryTitle: "If the company is a shareholder, a scanned copy of the original business license of the ultimate beneficiary",
    beneficiaryUpload: "Upload the license",
    authorizationTitle: "Authorization Of Business Obtained From Specific Gov. Authority (If Applicable)",
    authorizationTitleSmall: '(same as applied info in "3. Company Details")',
    authorizationUpload: "Upload authorization document(s)",
    legalConstitutionTitle: "Upload customized articles of association reviewed by lawyers",
    legalConstitutionUpload: "Upload customized articles of association reviewed by lawyers",
    applicantIdentityTitle: "A scanned copy of the applicant's original identification document",
    applicantIdentityTitle02: "An electronic photograph of the applicant holding the original identification document",
    notApplicantTitle: "Authorization of applicant – Scanned copy",
    authorizationFileUpload: "Upload authorized letter(s) of applicant for Application",
    applicantIdentityUpload: "Upload the original passport / IC of applicant (both front and back)",
    transferIdentityTitleSmall: '(same as applied info in "1. KYC Questionnaire")',
    transferSiteTitleSmall:
      '(i.e. recent three months\' utility bills, telephone bills, or third-party letters with name and address) (same as applied info in "1. KYC Questionnaire")',
    transferProfileAndArticles: "Business Profile & Articles of Association of the Proposed Company",
    transferProfileAndArticlesSmall: "(i.e. the latest business profile & articles of association of the proposed company)",
    transferProfileUpload: "Upload the business profile and articles of association",
    transferActivities: "Business Activities of the Proposed Company",
    transferActivitiesSmall:
      "(i.e. a document stating the main product(s) and/or services of the proposed company and the name of nominee director(s)/shareholder(s) (if applicable))",
    transferDescribeUpload: "Upload business activity description and other requested information",
    transferStructure: "Shareholder Structure of the Proposed Company",
    transferStructureSmall:
      "(i.e. shareholder structure chart, including name of direct/intermediary/ultimate shareholder(s), shareholding ratio, email, mobile number and mail address)",
    transferStructureUpload: "Upload shareholder structure of the proposed company",
    transferFinancial: "Latest Annual Financial Report of the Proposed Company (if applicable)",
    transferFinancialUpload: "Upload latest annual financial report",
    transferAddress: "Proof of Registered Office Address of the Proposed Company – Scanned Copy",
    transferAddressSmall: "(i.e. lease agreement, or property ownership certificate)",
    transferAddressUpload: "Upload proof of registered office address",
    transferSecretary: "Particulars of the Current Company Secretary",
    transferSecretarySmall: "(i.e. a document stating the name, contact email, contact mobile number and mail address of the current company secretary)",
    transferSecretaryUpload: "Upload the particulars of the current company secretary",

    comprehensiveProfileAndArticles: "Business Profile & Articles of Association of the Proposed Company",
    comprehensiveProfileAndFundArticles: "Business Profile & Articles of Association of the Proposed Fund Manager",
    comprehensiveProfileAndArticlesSmall: "(i.e. the latest business profile & articles of association of the proposed company)",
    comprehensiveProfileAndArticlesFundSmall: "(i.e. the latest business profile & articles of association of the proposed Fund Manager)",
    comprehensiveProfileUpload: "Upload the business profile and articles of association",
    comprehensiveActivities: "Business Activities of the Proposed Company",
    comprehensiveFundActivities: "Business Information of the Proposed Fund(s)",
    comprehensiveActivitiesSmall:
      "(i.e. a document stating the main product(s) and/or services of the proposed company and the name of nominee director(s)/shareholder(s) (if applicable))",
    comprehensiveActivitiesFundSmall: "(i.e. a document stating the main fund types, fund structure, investment strategy and/or services of the proposed Fund(s) (if applicable))",
    comprehensiveDescribeUpload: "Upload business activity description and other requested information",
    comprehensiveStructure: "Shareholder Structure of the Proposed Company",
    comprehensiveFundStructure: "Shareholder Structure of the Proposed Fund Manager",
    fundEquityStructure: "Shareholder Structure of the Proposed Fund(s)",
    comprehensiveStructureSmall:
      "(i.e. shareholder structure chart, including name of direct/intermediary/ultimate shareholder(s), shareholding ratio, email, mobile number and mail address)",
    comprehensiveStructureUpload: "Upload shareholder structure of the proposed company",
    comprehensiveStructureFundUpload: "Upload shareholder structure of the proposed fund manager",
    equityStructureFundUpload: "Upload shareholder structure of the proposed fund(s)",
    comprehensiveFinancial: "Latest Annual Financial Report of the Proposed Company (if applicable)",
    comprehensiveFundFinancial: "Latest Annual Financial Report of the Proposed Fund Manager and its Managed Fund(s) (if applicable)",
    comprehensiveFinancialUpload: "Upload latest annual financial report",
    comprehensiveAddress: "Proof of Registered Office Address of the Proposed Company – Scanned Copy",
    comprehensiveFundAddress: "Proof of Registered Office Address of the Proposed Fund Manager – Scanned Copy",
    comprehensiveAddressSmall: "(i.e. lease agreement, or property ownership certificate)",
    comprehensiveAddressUpload: "Upload proof of registered office address",
    comprehensiveSecretary: "Particulars of the Current Company Secretary",
    comprehensiveFundSecretary: "Particulars of the Current secretary of the fund manager and its managed fund(s)",
    comprehensiveSecretarySmall: "(i.e. a document stating the name, contact email, contact mobile number and mail address of the current company secretary)",
    comprehensiveSecretaryFundSmall:
      "(i.e. a document stating the name, contact email, contact mobile number and mail address of the current secretary of the fund manager and its managed fund(s))",
    comprehensiveSecretaryUpload: "Upload the particulars of the current company secretary",
    comprehensiveSecretaryFundUpload: "Upload the particulars of the current secretary of the fund manager and its managed fund(s)",
    comprehensiveFinance: "Particulars of the Proposed Company's Finance and Tax In-charge",
    comprehensiveFundFinance: "Particulars of the Finance and Tax In-charge, the Auditors of the Proposed Fund Manager and its Managed Fund(s)",
    comprehensiveFinanceSmall: "(i.e. a document stating the name, contact email, contact mobile number and mail address of the proposed company’s finance and tax in-charge)",
    comprehensiveFinanceFundSmall:
      "(i.e. a document stating the name, contact email, contact mobile number and mail address of the Finance and Tax In-charge, the Auditors of the Proposed Fund Manager and its Managed Fund(s))",
    comprehensiveFinanceUpload: "Upload the particulars of the Proposed Company's Finance and Tax In-charge",
    comprehensiveFinanceFundUpload: "Upload the particulars of the Finance and Tax In-charge, the Auditors of the Proposed Fund Manager and its Managed Fund(s)",
    comprehensiveIdentityTitleSmall: '(same as applied info in "1. KYC Questionnaire")',
    comprehensiveSiteTitleSmall:
      '(i.e. recent three months\' utility bills, telephone bills, or third-party letters with name and address) (same as applied info in "1. KYC Questionnaire")',
    comprehensiveBusinessTitleSmall: '(same as applied info in "1. KYC Questionnaire")',

    fundMessage: "Business Information of the Proposed Funds",
    fundMessageTitleSmall:
      "(i.e. (i) Business Profile of Fund(s); (ii) offering memorandum(s) of funds; (iii) a document stating the fund types, fund structure, investment strategy and/or services",
    fundMessageIncludingUpload: "Upload documents including requested information",
    fundMessageMemoUpload: "Upload offering memo of fund(s)",
    fundBusinessProfileUpload: "Upload business profile",

    fundPassport: "Passport / IC of Individual Shareholder(s) and Director(s) of the Fund(s)",
    fundSiteTitle: "Proof of Resident/Company Address of the Fund(s) – Scanned Copy",
    fundBusinessTitle: "Corporate Shareholder's Business Certificate & Articles of Association of the Fund(s) – Scanned Copy",

    fundManagerPassport: "Passport / IC of Individual Shareholder(s) and Director(s) of the Fund Manager",
    fundManagerSiteTitle: "Proof of Resident/Company Address of the Fund Manager – Scanned Copy",
    fundManagerBusinessTitle: "Corporate Shareholder's Business Certificate & Articles of Association of the Fund Manager – Scanned Copy",
    certificationRequirements: `Certification Requirements:\n
      Certified copy are documents certified to be true copies by a notary public. The following details must be stated on the certified document:\n
      (a) Name of the certifier;\n
      (b) Signature of the certifier;\n
      (c) Date of certification (date needs to be within recent three months);\n
      (d) Official seal/stamp of the certifier (if applicable);\n
      (e) Contact details of the certifier, including phone number, address and email address.
      `,
    promotionCertified: "Upload promotion related supporting, contact us if you need any clarification.",
    promotionCertifiedUpload: "Upload promotion related supporting",
    ultimateBeneficialId: "Ultimate Beneficial Owner(s)' ID/Business Certificate and Proof of Resident/Company Address",
    ultimateBeneficialIdTitleSmall:
      '(i.e. ID/Business certificate with name and address)(same as applied info in "1.KYC Questionnaire")(If the requested documents were uploaded elsewhere on this page, please upload a text file named "N/A" instead)',
    ultimateBeneficialIdTitleSmall02:
      '(i.e. ID/Business certificate with name and address)(same as applied info in "2.KYC Questionnaire")(If the requested documents were uploaded elsewhere on this page, please upload a text file named "N/A" instead)',
    ultimateBeneficialIdUpload: "Upload ID/Business certificate with name and address",
    epApplicantPersonalInfo: "EP Applicant's Personal Info",
    epApplicantPersonalInfoTitleSmall: '(Include: Passport, Local ID card, Academic certificate) (same as applied info in "3.Company Details")',
    epApplicantPersonalInfoUpload: "Upload Passport, Local ID card, and Academic certificate",
  },
};
